<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <span>{{ 'quoteTracking.quoteStatus' | cxTranslate }}</span>
        </div>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="text-padding" *ngIf="operation == status.EDIT">
          {{ 'quoteTracking.quoteEdit' | cxTranslate }}
        </div>
        <div class="text-padding" *ngIf="operation == status.ACCEPT">
          {{ 'quoteTracking.quoteConvert' | cxTranslate }}
        </div>
        <div class="text-padding" *ngIf="operation == status.ADDITIONAL">
          {{ 'quoteTracking.quoteConvert' | cxTranslate }}
        </div>
        <div class="text-padding" *ngIf="operation == status.MERGE">
          {{ 'quoteTracking.quoteMerge' | cxTranslate }}
        </div>
        <div class="row">
          <div class="col-8"></div>
          <div class="col-4">
            <div class="row">
              <div class="col-sm-6 col-md-6">
                <button
                  cxAutoFocus
                  class="vs-text-btn"
                  (click)="closeModal('close')"
                >
                  {{ 'quoteTracking.cancel' | cxTranslate }}
                </button>
              </div>
              <div class="col-sm-6 col-md-6 reject-btn">
                <button
                  cxAutoFocus
                  class="vs-primary-btn"
                  (click)="closeModal('edited-quote')"
                >
                  {{ 'quoteTracking.ok' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  